import confetti from "canvas-confetti";

/** Same two-burst sequence as feedback.jsx after a positive submit */
export function fireFeedbackConfetti() {
  try {
    confetti({ particleCount: 100, spread: 90, origin: { y: 0.5 } });
    window.setTimeout(() => confetti({ particleCount: 80, spread: 120, origin: { y: 0.6 } }), 200);
  } catch {
    /* ignore */
  }
}
